export enum CancelBtnType {
    Red = "Red",
    Slate = "Slate",
}






